<template>
  <div>
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="getTitle"
      :pageType="pageType + pageTypeName"
      :tables="tables"
    >
    </MultipleAreaBase>
  </div>
</template>
<script>
import MultipleAreaBase from './MultipleAreaBase'

export default {
  components: {
    MultipleAreaBase
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },

    pageType: { default: '' },

    tables: [
      // {
      //   items: { default: [] },
      //   itemKey: { default: '' }
      // }
    ]
  },
  data: () => ({
    displayFlg: false,
    pageTypeName: 'StatusHistory'
  }),
  methods: {
    close() {
      this.inputedValue.dialog = false
    },
    complete() {
      this.inputedValue.dialog = false
    }
  },
  computed: {
    getTitle() {
      return !this.title ? this.$t('common.input_status-history') : this.title
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
